module.exports = __webpack_public_path__ + "img/sp.5dc6a415.png";